import React from 'react';
import { Button, List as ListComponent } from '../../';



const ViewCostList = (params) => {

    return <>
        <div className=" form-element col-12">

            <ListComponent
                {...params}
                rightButtons={[
                ]}
                dataProviderName='persons/cost'
                title={"Costs"} />
        </div>
    </>
}

export default ViewCostList



